































import {Component, Vue} from 'vue-property-decorator';

import {apiService} from '../services/api-service';
import {Category, Collection} from "../model";
import KkImage from '@/components/KK-Image.vue';


@Component({
  components: {KkImage}
})
export default class Home extends Vue {
  msg: string = '';
  categories: Category[] = [];
  collections: Collection[] = [];

  created() {
    this.loadCategories();
    this.loadCollections();
  }

  async loadCategories() {
    this.categories = await apiService.loadCategories();
  }

  async loadCollections() {
    this.collections = await apiService.loadCollections();
  }

  goToCollection(col: Collection) {
    this.$router.push(`collection/${col.id}`);
  }

  goToCategory(cat: Category) {
    this.$router.push(`category/${cat.id}`);
  }
}
